<template>
  MODIFY MODIFY MODIFY MODIFY 
</template>

<script>


export default {
  name: 'BBSModify',
  props: {
  },
  data (){
    return {
    }
  },
  methods: {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
